var render = function render(){var _vm=this,_c=_vm._self._c;return _c('broadcast-card',{attrs:{"eyebrow":"Στατιστικά αγώνα","title":"Σύγκριση ομάδων"}},[_c('broadcast-compare',{attrs:{"sides":_vm.sides,"rows":_vm.rows}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }